import React from 'react';

export const CaretIcon = () => (
    <svg className="caret-icon" width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
            d="M0.762974 0L4 3.39811L7.23703 0L8 0.800943L4 5L0 0.800943L0.762974 0Z"/>
    </svg>
);
